module.exports = __webpack_public_path__ + "img/featuredartist (6).6aaea94f.jpg";